import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Input,
  Grid,
  Box,
  Text,
  Image,
  Flex,
  Button,
  Select,
  Checkbox,
  Card,
  CardBody,
  CardHeader,
  useToast,
  Heading,
  Stack,
  StackDivider,
  HStack,
  Avatar,
} from "@chakra-ui/react";
import { FaSync, FaPrint, FaWhatsapp, FaPaperPlane } from "react-icons/fa";
import { Link } from "react-router-dom";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const Message = () => {
  const toast = useToast();

  const [students, setStudents] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);

  const [filteredStudents, setFilteredStudents] = useState([]);
  const [search, setSearch] = useState("");
  const [classes, setClasses] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [checkedStudents, setCheckedStudents] = useState({});
  const school_id = sessionStorage.getItem("school_id");

  const capitalizeWords = (str) => {
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const getInitials = (name) => {
    return name
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase())
      .join("");
  };

  // Fetch students from API
  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/student/list_all_student.php?school_id=${school_id}`
        );
        if (response.data.status === "success") {
          setStudents(response.data.data);
          setFilteredStudents(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching students:", error);
      }
    };
    fetchStudents();
  }, []);

  const itemsPerPage = 25; // Define items per page
  const totalPages = Math.ceil(filteredStudents.length / itemsPerPage); // Calculate total pages

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const paginatedParents = filteredStudents.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  // Fetch classes from API
  useEffect(() => {
    const fetchClasses = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/class/class_master.php`
        );
        if (response.data.success) {
          setClasses(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching classes:", error);
      }
    };
    fetchClasses();
  }, []);

  // Fetch divisions from API
  useEffect(() => {
    const fetchDivisions = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/class/division.php`
        );
        if (response.data.success) {
          setDivisions(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching divisions:", error);
      }
    };
    fetchDivisions();
  }, []);

  // Function to capitalize the first letter of each word

  // Filter students
  const filterStudents = (classValue, divisionValue, query) => {
    const filtered = students.filter((student) => {
      const matchesClass = classValue ? student.class === classValue : true;
      const matchesDivision = divisionValue
        ? student.division === divisionValue
        : true;
      const matchesName = student.name
        .toLowerCase()
        .includes(query.toLowerCase());
      return matchesClass && matchesDivision && matchesName;
    });
    setFilteredStudents(filtered);
  };

  // Handle search input
  const handleSearch = (e) => {
    const query = e.target.value;
    setSearch(query);
    filterStudents(selectedClass, selectedDivision, query);
  };

  // Handle class and division changes
  const handleClassChange = (e) => {
    setSelectedClass(e.target.value);
    filterStudents(e.target.value, selectedDivision, search);
  };

  const handleDivisionChange = (e) => {
    setSelectedDivision(e.target.value);
    filterStudents(selectedClass, e.target.value, search);
  };

  // Handle WhatsApp click
  const handleWhatsAppClick = (number) => {
    const message = encodeURIComponent(
      "Hello, I'm contacting you regarding your child."
    );
    window.open(`https://wa.me/${number}?text=${message}`, "_blank");
  };

  // Bulk WhatsApp function (with delay)
  const handleBulkWhatsAppClick = () => {
    const selectedNumbers = Object.keys(checkedStudents)
      .filter((id) => checkedStudents[id])
      .map((id) => {
        const student = filteredStudents.find((s) => s.id === id);
        return student ? student.father_number : null;
      })
      .filter((number) => number);

    if (selectedNumbers.length > 0) {
      const message = encodeURIComponent(
        "Hello, I'm contacting you regarding your child."
      );

      const sendWhatsAppMessages = (numbers, index = 0) => {
        if (index < numbers.length) {
          const number = numbers[index].startsWith("0")
            ? `+91${numbers[index].slice(1)}`
            : numbers[index];
          const url = `https://wa.me/${number}?text=${message}`;
          window.open(url, "_blank");
          setTimeout(() => sendWhatsAppMessages(numbers, index + 1), 2000);
        }
      };

      sendWhatsAppMessages(selectedNumbers);
    } else {
      toast({
        title: "Selection Required",
        description: "Please select at least one student.",
        status: "warning",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  // Handle checkbox change
  const handleCheckboxChange = (studentId) => {
    setCheckedStudents((prev) => ({
      ...prev,
      [studentId]: !prev[studentId],
    }));
  };

  return (
    <Box>
      <div className="teacher-list-container">
        <div className="header">
          <h1 style={{ fontSize: "20px", margin: 0 }}>Message</h1>
          {/* <div className="action-buttons">
            <Button
              onClick={() => window.location.reload()}
              boxShadow="md"
              backgroundColor="white"
              fontSize="11px"
            >
              <FaSync color="#515B73" />
            </Button>
            <Button backgroundColor="white" fontSize="11px" boxShadow="md">
              <FaPrint color="#515B73" />
              Print PDF
            </Button>
          </div> */}
        </div>
        <div className="breadcrumb">
          <Link
            to="/admin"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Dashboard</span>
          </Link>{" "}
          / <span>Announcement</span> / <span>Message</span>
        </div>
      </div>
      <Box mt={3}></Box>
      {/* Class and Division Selection moved here */}
      <Box p={6}>
        <Flex
          direction={{ base: "column", md: "row" }}
          justify="space-between"
          align="center"
          className="sb"
          mb={2}
          p={3}
          // mt={2}
        >
          <Flex
            align="center"
            gap={4}
            direction={{ base: "column", md: "row" }}
            width={{ base: "100%", md: "300px" }} // 100% width on mobile, fixed width on larger screens
          >
            <Flex
              align="center"
              gap={4}
              width={{ base: "100%", md: "auto" }}
              justify={{ base: "flex-start", md: "flex-start" }}
              whiteSpace="nowrap" // Prevents breaking to a new line
            >
              <Text>Rows Per Page:</Text>
              <Select
                width={{ base: "auto", md: "100px" }}
                value={rowsPerPage}
                onChange={(e) => setRowsPerPage(Number(e.target.value))}
                borderColor="#E9EDF4"
              >
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </Select>
            </Flex>
          </Flex>
          <HStack mt={{ base: "2" }}>
            {/* Class Selection */}
            <Select
              width={{ base: "100%", md: "200px" }}
              placeholder="Select Class"
              onChange={handleClassChange}
              value={selectedClass}
              fontSize="sm"
            >
              {classes.map((cls) => (
                <option key={cls.id} value={cls.class_name}>
                  {cls.class}
                </option>
              ))}
            </Select>
            {/* Division Selection */}
            <Select
              width={{ base: "100%", md: "200px" }}
              placeholder="Select Division"
              onChange={handleDivisionChange}
              value={selectedDivision}
              fontSize="sm"
            >
              {divisions.map((div) => (
                <option key={div.id} value={div.division_name}>
                  {div.division}
                </option>
              ))}
            </Select>
            {/* Search Bar on the Right */}
            <Input
              width={{ base: "100%", md: "200px" }} // 100% width on mobile, fixed width on larger screens
              placeholder="Search by name..."
              value={search}
              onChange={handleSearch}
              fontSize="sm"
            />{" "}
          </HStack>
        </Flex>

        <Grid templateColumns="repeat(auto-fill, minmax(280px, 1fr))" gap={6}>
          {paginatedParents.map((student) => {
            // Log each student object as it is rendered
            console.log("Rendering student:", student);

            return (
              <Card
                key={student.id}
                boxShadow="md"
                padding={0}
                height="fit-content"
              >
                <CardHeader padding={1}>
                  <Flex justifyContent="space-between" alignItems="start">
                    {/* Left Section: Checkbox, Image, Name, and Details */}
                    <Flex alignItems="center">
                      {/* Checkbox */}
                      <Checkbox
                        size="sm"
                        isChecked={!!checkedStudents[student.id]}
                        onChange={() => {
                          handleCheckboxChange(student.id);
                          console.log(
                            `Checkbox for ${
                              student.name
                            } is now ${!!checkedStudents[student.id]}`
                          );
                        }}
                        mr={2}
                        marginBottom={5}
                      />

                      {/* Check if the image exists, if not fallback to the initials of the name */}
                      {/* {student.image_url ? (
                        <Image
                          src={student.image_url}
                          borderRadius="full"
                          boxSize="30px"
                          mr={5}
                          mb={5}
                        />
                      ) : (
                        <Box
                          borderRadius="full"
                          bg="teal.500"
                          color="white"
                          boxSize="40px"
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                          mr={2}
                        >
                          <Text fontSize="lg">
                            {getInitials(capitalizeWords(student.name))}
                          </Text>
                        </Box>
                      )} */}
                       <Avatar
                                    src={student.image_url}
                                    name={student.name}
                                    alt={student.name}
                                    size="sm"
                                    mr={5}
                                    objectFit="cover"
                                    onError={(e) => {
                                      e.target.src =
                                        "https://t4.ftcdn.net/jpg/02/29/75/83/360_F_229758328_7x8jwCwjtBMmC6rgFzLFhZoEpLobB6L8.jpg";
                                    }}
                                  />
                      
                      

                      {/* Student Name and Details */}
                      <Box mr={4}>
                        <Heading size="xs" noOfLines={1}>
                          {capitalizeWords(student.name)}
                        </Heading>
                        <Text fontSize="sm" noOfLines={1}>
                          Class: {student.class}
                        </Text>
                        <Text fontSize="sm" noOfLines={1}>
                          Division: {student.division}
                        </Text>
                      </Box>
                    </Flex>

                    {/* Right Section: WhatsApp Button */}
                    <Button
                      onClick={() => {
                        handleWhatsAppClick(student.father_number);
                        console.log(
                          `WhatsApp button clicked for ${student.name}`
                        );
                      }}
                      colorScheme="green"
                      size="xs"
                    >
                      <FaWhatsapp />
                    </Button>
                  </Flex>
                </CardHeader>
              </Card>
            );
          })}
        </Grid>
        <Flex justify="end" borderTopWidth="1px" mt={1} className="sb2" p={3}>
          <Button
            onClick={() => handlePageChange(currentPage - 1)}
            isDisabled={currentPage === 1}
          >
            Prev
          </Button>
          <Stack direction="row" mx={2}>
            {currentPage > 1 && (
              <>
                <Button onClick={() => handlePageChange(1)}>1</Button>
                {currentPage > 2 && <Text>...</Text>}
              </>
            )}
            <Button backgroundColor="teal" color="white">
              {currentPage}
            </Button>
            {currentPage < totalPages - 1 && (
              <>
                <Text>...</Text>
                <Button onClick={() => handlePageChange(totalPages)}>
                  {totalPages}
                </Button>
              </>
            )}
          </Stack>
          <Button
            onClick={() => handlePageChange(currentPage + 1)}
            isDisabled={currentPage === totalPages}
          >
            Next
          </Button>
        </Flex>
      </Box>
    </Box>
  );
};

export default Message;
